export var Actions;
(function (Actions) {
    Actions["TOGGLE_AUDIO"] = "TOGGLE_AUDIO";
    Actions["CHANGE_AUDIO_STATUS"] = "CHANGE_AUDIO_STATUS";
})(Actions || (Actions = {}));
//# sourceMappingURL=Actions.js.map